export default function EmptyState({ icon: Icon, title, hint }) {
  return (
    <div className="border border-dashed border-border rounded-sm py-16 grid place-items-center text-center gap-2" data-testid="empty-state">
      {Icon && <Icon className="h-8 w-8 text-muted-foreground/60" />}
      <p className="text-sm font-medium">{title}</p>
      {hint && <p className="text-xs text-muted-foreground max-w-xs">{hint}</p>}
    </div>
  );
}
